export default "__VITE_ASSET__b3ca1a77__"